const DragDropEvents = {
    dragenter: 'dragenter',
    dragleave: 'dragleave',
    dragover: 'dragover',
    drop: 'drop',
};

export {
    DragDropEvents,
};